import * as types from '../types/wall'
import { getNxAuthTokenFromState, getWallIdFromState } from './actionsHelpers'

import apiWall from 'api/wall'

const api = apiWall.clientInstance
const getNxAuthTokenFromStore = (getState) => getNxAuthTokenFromState(getState)
const getWallIdFromStore = (getState) => getWallIdFromState(getState)

const setNodeAct = (node) => ({ type: types.ADD_NODE, node })
const updNodeAct = (node) => ({ type: types.UPDATE_NODE, node })
const setWallAct = (wall) => ({ type: types.ADD_WALL, wall })

const wallGetFetchRequestAct = () => ({ type: types.WALL_FETCH_REQUEST })
const wallGetFetchSuccessAct = (wall) => ({ type: types.WALL_FETCH_SUCCESS, wall })

const wallAddPostRequestAct = () => ({ type: types.WALL_ADD_POST_REQUEST })
const wallAddPostSuccessAct = (node) => ({ type: types.WALL_ADD_POST_SUCCESS, node })

const wallSendEventRequestAct = () => ({ type: types.WALL_ADD_EVENT_REQUEST })
const wallSendEventSuccessAct = (node) => ({ type: types.WALL_ADD_EVENT_SUCCESS, node })

export const addNode = (node) => (dispatch) => dispatch(setNodeAct(node))
export const updateNode = (node) => (dispatch) => dispatch(updNodeAct(node))
export const addWall = (wall) => (dispatch) => dispatch(setWallAct(wall))

const getWall = (params) => async (dispatch, getState) => {
  try {
    const nxAuthToken = getNxAuthTokenFromStore(getState)
    dispatch(wallGetFetchRequestAct())

    api.setInheritToken(nxAuthToken, 'nxDashboard')

    const { data } = await api.getWall(params.userId, true, params.eventType)

    if (data.nodeInfos?.length) data.nodeInfos[data.nodeInfos.length - 1].firstMessage = true

    dispatch(wallGetFetchSuccessAct(data))

    return data
  } catch(error) {
    console.error(params, error)

    dispatch(wallGetFetchSuccessAct({}))
  }
}

const writePost = ({ post }) => (dispatch, getState) =>
  new Promise((resolve, reject) => {
    const nxAuthToken = getNxAuthTokenFromStore(getState)
    const wallId = getWallIdFromStore(getState)
    dispatch(wallAddPostRequestAct())

    api.setInheritToken(nxAuthToken, 'nxDashboard')
    api
      .addEventToWall(wallId, post.nodeId, post.wallNodeType, post.eventType, post.userId, post.messageInfo, 'node', true)
      .then(({ data, status }) => {
        if (status === 200) {
          dispatch(wallAddPostSuccessAct(data))
          return resolve(data)
        }
        return reject(data)
      })
  })

const sendEvent = ({ wallEvent }) => (dispatch, getState) =>
  new Promise((resolve, reject) => {
    const nxAuthToken = getNxAuthTokenFromStore(getState)
    const wallId = getWallIdFromStore(getState)
    dispatch(wallSendEventRequestAct())

    api.setInheritToken(nxAuthToken, 'nxDashboard')
    api
      .addEventToWall(wallId, wallEvent.nodeId, wallEvent.wallNodeType, wallEvent.eventType, wallEvent.userId, wallEvent.messageInfo, 'node', true)
      .then(({ data, status }) => {
        if (status === 200) {
          dispatch(wallSendEventSuccessAct(data))
          return resolve(data)
        }
        return reject(data)
      })
  })

export default {
  getWall,
  writePost,
  sendEvent,
}
